<template>
  <q-page padding>

    <div class="row">
      <div class="col text-center">
        <img src="../assets/logo-sepet_512x512.png" class="responsive">
        <h3 class="text-primary text-weight-bold">{{ msg }}</h3>
        <q-btn :to="{name:'login'}" round color="primary" icon="account_circle" />
      </div>
    </div>

  </q-page>
</template>

<script>
import {mapState, mapGetters} from 'vuex';

export default {
  data() {
    return {
      msg: 'SEPET App',
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['isAuthenticated', 'getToken'])
  }
}
</script>
<style lang="stylus">

</style>